import messageTemplate from '../../http/requests/messageTemplate';

export default {
  
  loadMessageTemplates({ commit }) {
    return new Promise((resolve) => {
      messageTemplate.fetch().then((response) => {
        commit('SET_TEMPLATES', response.data.data.messageTemplates)
        resolve({})
      })
    })
  },
}
